export default import.meta.ROLLDOWN_FILE_URL_GYrsNiQcdpKaWykKe2xG4Q